'use strict';

/**
 *
 * @name: nownessApp.seasons
 *
 */

import SeasonsConfig from './seasons.config';
import SeasonsAnalyticsFactory from './seasons-analytics.factory';

import './seasons-landing/seasons-landing.index.scss';

const SeasonsModule = angular
  .module('nownessApp.seasons', [])
  .config(SeasonsConfig)
  .factory('seasonsAnalytics', SeasonsAnalyticsFactory);

export default SeasonsModule.name;



// WEBPACK FOOTER //
// ./app/pages/seasons/seasons.module.js